module.exports = __webpack_public_path__ + "img/yentek_banner_cut.09158b0e.jpg";